import { AutocompleteInput } from "@/components/admin/autocomplete-input";
import { ReferenceInput } from "@/components/admin/reference-input";
import { SelectInput } from "@/components/admin/select-input";
import { TextInput } from "@/components/admin/text-input";
import { required } from "ra-core";
import { DateTimeInput } from "@/components/admin";

import { contactOptionText } from "../misc/ContactOption";
import { useConfigurationContext } from "../root/ConfigurationContext";
import { useTaskStatusChoices } from "./taskStatuses";

/** A task must concern a contact or a company (the database enforces it too). */
const requireContactOrCompany = (
  _value: unknown,
  values: { contact_id?: unknown; company_id?: unknown },
) =>
  values?.contact_id || values?.company_id
    ? undefined
    : "resources.tasks.validation.contact_or_company";

export const TaskFormContent = ({
  selectContact,
}: {
  selectContact?: boolean;
}) => {
  const { taskTypes } = useConfigurationContext();
  const taskStatusChoices = useTaskStatusChoices();
  return (
    <div className="flex flex-col gap-4">
      <TextInput
        autoFocus
        source="text"
        validate={required()}
        className="m-0"
        helperText={false}
      />
      <TextInput source="note" multiline helperText={false} />
      {selectContact && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <ReferenceInput source="contact_id" reference="contacts_summary">
            <AutocompleteInput
              label="resources.tasks.fields.contact_id"
              optionText={contactOptionText}
              helperText={false}
              validate={requireContactOrCompany}
              modal
            />
          </ReferenceInput>
          <ReferenceInput source="company_id" reference="companies">
            <AutocompleteInput
              label="resources.tasks.fields.company_id"
              optionText="name"
              helperText={false}
              validate={requireContactOrCompany}
              modal
            />
          </ReferenceInput>
        </div>
      )}

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <DateTimeInput
          source="due_date"
          helperText={false}
          validate={required()}
        />
        <SelectInput
          source="type"
          validate={required()}
          choices={taskTypes}
          optionText="label"
          optionValue="value"
          defaultValue="none"
          helperText={false}
        />
        <SelectInput
          source="status"
          validate={required()}
          choices={taskStatusChoices}
          optionText="label"
          optionValue="value"
          translateChoice={false}
          defaultValue="todo"
          helperText={false}
        />
      </div>
    </div>
  );
};
